import { makeStock } from '../../utils/common';

const initialState: any = {
  data: [],
  m: {}
};

export const INIT_REQUEST_BITHUMB: string = 'BITHUMB/INIT_REQUEST'; 
export const INIT_SUCCESS_BITHUMB: string = 'BITHUMB/INIT_SUCCESS_BITHUMB'; 
export const RECEIVE: string = 'BITHUMB/RECEIVE';

type UserAction = any;

function bithumbReducer(state: any = initialState, action: UserAction) {
  switch (action.type) {
    case RECEIVE:
      let tempData = [...state.data]
      
      action.payload.data.forEach((data: any) => {
        tempData[state.m[data.code]] = data
      })
      return {
        ...state,
        data: tempData
      };
   
    case INIT_SUCCESS_BITHUMB:
      return {
        ...state,
        data: action.payload.data.map((coinCode: any) => makeStock(coinCode, coinCode)),
        m: action.payload.m
      }

    default:
      return state;
  }
}

export default bithumbReducer;
